// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { VersionableFragmentDoc } from '../../../components/ReadyPlanVersionHeader.generated';
import { ProductOfferingConfigUtils_ReadyPlanOptionFragmentDoc } from '../../components/ProductOfferingConfigUtils.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingCheckoutStartingConfigPageQueryVariables = Types.Exact<{
  productOfferingId: Types.Scalars['ID']['input'];
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type ProductOfferingCheckoutStartingConfigPageQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, name: string, development?: { __typename?: 'Development', id: string } | null | undefined, project?:
      | { __typename: 'StandaloneProject', id: string }
      | { __typename: 'Region', id: string }
      | { __typename: 'Market', id: string }
      | { __typename: 'Community', id: string, children: Array<{ __typename?: 'Subdivision', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType } }> }
      | { __typename: 'Subdivision', id: string }
      | { __typename: 'Lot', id: string }
      | { __typename: 'Structure', id: string }
      | { __typename: 'Unit', id: string }
     | null | undefined, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateActive?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } }>, checkoutStartingConfig?: { __typename?: 'ProductOfferingStartingConfig', id: string, salesPriceInCents?: number | null | undefined, type: { __typename?: 'ProductOfferingStartingConfigTypeDetail', code: Types.ProductOfferingStartingConfigType, name: string }, pinnedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }> } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', displayName: string, order: number, active: boolean, id: string, name: string, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string } }>, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, required: boolean, isSingleOptionGroup: boolean, active: boolean, order: number, step?: { __typename?: 'CheckoutConfigOptionGroupStepDetail', code: Types.CheckoutConfigOptionGroupStep, name: string } | null | undefined } }> } };

export type ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables = Types.Exact<{
  productOfferingId: Types.Scalars['ID']['input'];
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, checkoutStartingConfig?: { __typename?: 'ProductOfferingStartingConfig', id: string, expandedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number } }> } | null | undefined } };

export type ProductOfferingCheckoutStartingConfig_SaveMutationVariables = Types.Exact<{
  input: Types.SaveProductOfferingStartingConfigInput;
}>;


export type ProductOfferingCheckoutStartingConfig_SaveMutation = { __typename?: 'Mutation', saveProductOfferingStartingConfig: { __typename?: 'SaveProductOfferingStartingConfigResult', productOfferingStartingConfig: { __typename?: 'ProductOfferingStartingConfig', id: string, salesPriceInCents?: number | null | undefined, type: { __typename?: 'ProductOfferingStartingConfigTypeDetail', code: Types.ProductOfferingStartingConfigType, name: string }, pinnedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }> } } };

export type ProductOfferingCheckoutStartingConfig_DetailFragment = { __typename?: 'ProductOfferingStartingConfig', id: string, salesPriceInCents?: number | null | undefined, type: { __typename?: 'ProductOfferingStartingConfigTypeDetail', code: Types.ProductOfferingStartingConfigType, name: string }, pinnedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }> };

export const ProductOfferingCheckoutStartingConfig_DetailFragmentDoc = gql`
    fragment ProductOfferingCheckoutStartingConfig_Detail on ProductOfferingStartingConfig {
  id
  salesPriceInCents
  type {
    code
    name
  }
  pinnedOptions {
    id
    active
  }
}
    `;
export const ProductOfferingCheckoutStartingConfigPageDocument = gql`
    query ProductOfferingCheckoutStartingConfigPage($productOfferingId: ID!, $versionId: ID) {
  productOffering(id: $productOfferingId, versionId: $versionId) {
    ...Named
    development {
      id
    }
    project {
      id
      __typename
      ... on Community {
        id
        children {
          id
          lotType {
            code
          }
        }
      }
    }
    version {
      id
    }
    aggregateActive {
      id
    }
    aggregateCheckout {
      id
    }
    aggregateVersions {
      ...Versionable
    }
    checkoutStartingConfig {
      ...ProductOfferingCheckoutStartingConfig_Detail
    }
    options {
      ...ProductOfferingConfigUtils_ReadyPlanOption
    }
  }
}
    ${NamedFragmentDoc}
${VersionableFragmentDoc}
${ProductOfferingCheckoutStartingConfig_DetailFragmentDoc}
${ProductOfferingConfigUtils_ReadyPlanOptionFragmentDoc}`;

/**
 * __useProductOfferingCheckoutStartingConfigPageQuery__
 *
 * To run a query within a React component, call `useProductOfferingCheckoutStartingConfigPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingCheckoutStartingConfigPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingCheckoutStartingConfigPageQuery({
 *   variables: {
 *      productOfferingId: // value for 'productOfferingId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useProductOfferingCheckoutStartingConfigPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingCheckoutStartingConfigPageQuery, ProductOfferingCheckoutStartingConfigPageQueryVariables> & ({ variables: ProductOfferingCheckoutStartingConfigPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingCheckoutStartingConfigPageQuery, ProductOfferingCheckoutStartingConfigPageQueryVariables>(ProductOfferingCheckoutStartingConfigPageDocument, options);
      }
export function useProductOfferingCheckoutStartingConfigPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingCheckoutStartingConfigPageQuery, ProductOfferingCheckoutStartingConfigPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingCheckoutStartingConfigPageQuery, ProductOfferingCheckoutStartingConfigPageQueryVariables>(ProductOfferingCheckoutStartingConfigPageDocument, options);
        }
// @ts-ignore
export function useProductOfferingCheckoutStartingConfigPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingCheckoutStartingConfigPageQuery, ProductOfferingCheckoutStartingConfigPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingCheckoutStartingConfigPageQuery, ProductOfferingCheckoutStartingConfigPageQueryVariables>;
export function useProductOfferingCheckoutStartingConfigPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingCheckoutStartingConfigPageQuery, ProductOfferingCheckoutStartingConfigPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingCheckoutStartingConfigPageQuery | undefined, ProductOfferingCheckoutStartingConfigPageQueryVariables>;
export function useProductOfferingCheckoutStartingConfigPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingCheckoutStartingConfigPageQuery, ProductOfferingCheckoutStartingConfigPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingCheckoutStartingConfigPageQuery, ProductOfferingCheckoutStartingConfigPageQueryVariables>(ProductOfferingCheckoutStartingConfigPageDocument, options);
        }
export type ProductOfferingCheckoutStartingConfigPageQueryHookResult = ReturnType<typeof useProductOfferingCheckoutStartingConfigPageQuery>;
export type ProductOfferingCheckoutStartingConfigPageLazyQueryHookResult = ReturnType<typeof useProductOfferingCheckoutStartingConfigPageLazyQuery>;
export type ProductOfferingCheckoutStartingConfigPageSuspenseQueryHookResult = ReturnType<typeof useProductOfferingCheckoutStartingConfigPageSuspenseQuery>;
export type ProductOfferingCheckoutStartingConfigPageQueryResult = ApolloReactCommon.QueryResult<ProductOfferingCheckoutStartingConfigPageQuery, ProductOfferingCheckoutStartingConfigPageQueryVariables>;
export const ProductOfferingCheckoutStartingConfig_CalculatedConfigDocument = gql`
    query ProductOfferingCheckoutStartingConfig_CalculatedConfig($productOfferingId: ID!, $versionId: ID) {
  productOffering(id: $productOfferingId, versionId: $versionId) {
    id
    checkoutStartingConfig {
      id
      expandedOptions {
        ...DisplayNamed
        optionGroup {
          id
          order
        }
      }
    }
  }
}
    ${DisplayNamedFragmentDoc}`;

/**
 * __useProductOfferingCheckoutStartingConfig_CalculatedConfigQuery__
 *
 * To run a query within a React component, call `useProductOfferingCheckoutStartingConfig_CalculatedConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingCheckoutStartingConfig_CalculatedConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingCheckoutStartingConfig_CalculatedConfigQuery({
 *   variables: {
 *      productOfferingId: // value for 'productOfferingId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useProductOfferingCheckoutStartingConfig_CalculatedConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery, ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables> & ({ variables: ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery, ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables>(ProductOfferingCheckoutStartingConfig_CalculatedConfigDocument, options);
      }
export function useProductOfferingCheckoutStartingConfig_CalculatedConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery, ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery, ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables>(ProductOfferingCheckoutStartingConfig_CalculatedConfigDocument, options);
        }
// @ts-ignore
export function useProductOfferingCheckoutStartingConfig_CalculatedConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery, ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery, ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables>;
export function useProductOfferingCheckoutStartingConfig_CalculatedConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery, ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery | undefined, ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables>;
export function useProductOfferingCheckoutStartingConfig_CalculatedConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery, ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery, ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables>(ProductOfferingCheckoutStartingConfig_CalculatedConfigDocument, options);
        }
export type ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryHookResult = ReturnType<typeof useProductOfferingCheckoutStartingConfig_CalculatedConfigQuery>;
export type ProductOfferingCheckoutStartingConfig_CalculatedConfigLazyQueryHookResult = ReturnType<typeof useProductOfferingCheckoutStartingConfig_CalculatedConfigLazyQuery>;
export type ProductOfferingCheckoutStartingConfig_CalculatedConfigSuspenseQueryHookResult = ReturnType<typeof useProductOfferingCheckoutStartingConfig_CalculatedConfigSuspenseQuery>;
export type ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryResult = ApolloReactCommon.QueryResult<ProductOfferingCheckoutStartingConfig_CalculatedConfigQuery, ProductOfferingCheckoutStartingConfig_CalculatedConfigQueryVariables>;
export const ProductOfferingCheckoutStartingConfig_SaveDocument = gql`
    mutation ProductOfferingCheckoutStartingConfig_Save($input: SaveProductOfferingStartingConfigInput!) {
  saveProductOfferingStartingConfig(input: $input) {
    productOfferingStartingConfig {
      ...ProductOfferingCheckoutStartingConfig_Detail
    }
  }
}
    ${ProductOfferingCheckoutStartingConfig_DetailFragmentDoc}`;

/**
 * __useProductOfferingCheckoutStartingConfig_SaveMutation__
 *
 * To run a mutation, you first call `useProductOfferingCheckoutStartingConfig_SaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingCheckoutStartingConfig_SaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productOfferingCheckoutStartingConfigSaveMutation, { data, loading, error }] = useProductOfferingCheckoutStartingConfig_SaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductOfferingCheckoutStartingConfig_SaveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProductOfferingCheckoutStartingConfig_SaveMutation, ProductOfferingCheckoutStartingConfig_SaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProductOfferingCheckoutStartingConfig_SaveMutation, ProductOfferingCheckoutStartingConfig_SaveMutationVariables>(ProductOfferingCheckoutStartingConfig_SaveDocument, options);
      }
export type ProductOfferingCheckoutStartingConfig_SaveMutationHookResult = ReturnType<typeof useProductOfferingCheckoutStartingConfig_SaveMutation>;
export type ProductOfferingCheckoutStartingConfig_SaveMutationResult = ApolloReactCommon.MutationResult<ProductOfferingCheckoutStartingConfig_SaveMutation>;